export default __webpack_public_path__ + "static/media/screen2.7a268b4f.png";